import React from 'react'
import { Modal } from 'hljd'
const confirm = Modal.confirm

export default store => {
  const deleteGoods = id => {
    confirm({
      title: '确认要删除该商品吗',
      okText: '确定',
      cancelText: '取消',
      onOk() {
        store.removeFranchise(id)
      },
      onCancel() {}
    })
  }
  return [
    {
      title: '商品名称',
      dataIndex: 'title',
      key: 'title',
      width: 280,
      render: (text, { cover_image, status, is_sold_out, id }) => {
        return (
          <div className="table-title">
            <div className="table-title-left">
              <img
                src={cover_image.img}
                style={{
                  maxWidth: '100px',
                  maxHeight: '100px',
                  display: 'block'
                }}
              />
            </div>
            <div className="table-title-right">
              {status == 3 || is_sold_out == true ? (
                <a>{text}</a>
              ) : (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/hunpin/detail_${id}`}
                >
                  {text}
                </a>
              )}
            </div>
          </div>
        )
      }
    },
    {
      title: '商品类型',
      key: 'type',
      dataIndex: 'type',
      width: 126,
      render: type => {
        if (type == '1') {
          return <span style={{ color: '#FF8C30' }}>婚礼纪直供</span>
        } else {
          return <span>自有</span>
        }
      }
    },
    {
      title: '价格',
      key: 'show_price',
      dataIndex: 'show_price',
      width: 126,
      render: show_price => {
        return <span>￥{show_price}</span>
      }
    },
    {
      title: '售出数',
      key: 'sold_count',
      dataIndex: 'sold_count',
      width: 100
    },
    {
      title: '收藏数',
      key: 'collectors_count',
      dataIndex: 'collectors_count',
      width: 100
    },
    {
      title: '上架时间',
      key: 'created_at',
      dataIndex: 'created_at',
      width: 100
    },
    {
      title: '操作',
      key: 'operate',
      dataIndex: 'operate',
      width: 80,
      render: (text, { status, id }) => {
        return (
          <div className="table-operate">
            <div>
              <span className="delete" onClick={() => deleteGoods(id)}>
                删除
              </span>
            </div>
          </div>
        )
      }
    },
    {
      title: '排序',
      key: 'sort',
      dataIndex: 'sort',
      width: 150,
      render: (text, record, index) => {
        return (
          <div className="table-sort">
            <button
              disabled={index == 0}
              onClick={() => store.orderFn(record.id, index, 'up')}
              className={index == 0 ? 'disabled' : ''}
            />
            <button
              disabled={index == store.listLen - 1 || store.listLen == 1}
              onClick={() => store.orderFn(record.id, index, 'down')}
              className={
                index == store.listLen - 1 || store.listLen == 1
                  ? 'disabled'
                  : ''
              }
            />
            <button
              disabled={index == 0}
              onClick={() => store.orderFn(record.id, index, 'top')}
              className={index == 0 ? 'disabled' : ''}
            />
          </div>
        )
      }
    }
  ]
}
